import * as Yup from 'yup';

export const passwordSchema = Yup.object().shape({
  password: Yup.string()
    .matches(/^(?=.*\d)(?=.*[A-Za-z])[0-9A-Za-z!@.\-_#*$%]{8,30}$/, 'Le mot de passe doit respecter le format requis')
    .required('Veuillez renseigner un mot de passe'),
  passwordConfirmation: Yup.string().oneOf([Yup.ref('password'), null], 'Les mots de passe ne sont pas identiques'),
});
